import script from "./VolunteerImpactCard.vue?vue&type=script&setup=true&lang=js"
export * from "./VolunteerImpactCard.vue?vue&type=script&setup=true&lang=js"

import "./VolunteerImpactCard.vue?vue&type=style&index=0&id=62c07f5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62c07f5c"]])

export default __exports__